import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";
export const progressNoteQueryParams = {
  progressNoteClassification: parseAsArrayOf(parseAsString, ",")
};
export function useProgressNoteColumnFilters() {
  return useQueryStates(progressNoteQueryParams);
}